import { render, staticRenderFns } from "./boss.vue?vue&type=template&id=24dd18b6"
import script from "./boss.vue?vue&type=script&lang=js"
export * from "./boss.vue?vue&type=script&lang=js"
import style0 from "./boss.vue?vue&type=style&index=0&id=24dd18b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports